export default __webpack_public_path__ + "static/media/capture.6859b423.png";